/* eslint-disable jsx-a11y/label-has-for */
import React, { useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
// eslint-disable-next-line css-modules/no-unused-class
import s from './Gallery.scss';
import Carousel from '../../../Carousel';
import Clickable from '../../../Clickable';
import List from '../../../List';
import ImageUpload from '../ImageUpload/ImageUpload';

const Gallery = ({
  cards,
  cardSelected,
  cardOccasionSelected,
  onCategoryChange,
  onGalleryImageChange,
  onUploadImage,
  messages,
  formatMessage,
}) => {
  const ref = useRef(null);
  const selectedOccasion = cards.find(c => c.value === cardOccasionSelected);

  return (
    <Fragment>
      <List container justify="flex-start" spacing={8}>
        {cards.map(({ label, value }) => (
          <List
            item
            component="li"
            xs={12}
            md={16}
            key={value}
            style={{ marginBottom: '8px' }}
          >
            <Clickable
              label={label}
              value={value}
              onClick={e => {
                e.preventDefault();
                onCategoryChange(value, e);
              }}
              basic
              selected={value === cardOccasionSelected}
            />
          </List>
        ))}
      </List>
      <List container justify="flex-start" spacing={8}>
        <List item component="li" xs={12} md={16}>
          <Clickable
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              ref.current.click();
            }}
            label={formatMessage({ ...messages.uploadImage })}
            primary
          />
          <ImageUpload
            ref={ref}
            type="file"
            accept="image/*"
            name="userImageUpload"
            className="visually-hidden"
            onChange={(_, files) => onUploadImage(files)}
          />
        </List>
      </List>
      <Carousel
        rootClass={s.slider}
        itemsPerSlide={4}
        arrows
        arrowsClass="basic"
        ariaLabel="Gallery images"
      >
        {selectedOccasion.images.map(({ id, imageUri }) => (
          <label key={id} className={s.card} htmlFor={`galleryImageId-${id}`}>
            <input
              tabIndex={0}
              type="radio"
              id={`galleryImageId-${id}`}
              value={id}
              checked={cardSelected === id}
              name="galleryImageId"
              className="visually-hidden"
              onChange={({ target }) => onGalleryImageChange(target.value)}
            />
            <span className={s.card__image}>
              <img
                src={imageUri}
                alt={`${selectedOccasion.label} ${id}`}
                crossOrigin="anonymous"
              />
            </span>
          </label>
        ))}
      </Carousel>
    </Fragment>
  );
};

Gallery.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  cardSelected: PropTypes.string,
  cardOccasionSelected: PropTypes.string,
  onCategoryChange: PropTypes.func.isRequired,
  onGalleryImageChange: PropTypes.func.isRequired,
  onUploadImage: PropTypes.func.isRequired,
  messages: PropTypes.shape().isRequired,
  formatMessage: PropTypes.func.isRequired,
};

Gallery.defaultProps = {
  cardOccasionSelected: undefined,
  cardSelected: undefined,
};

export default withStyles(s)(Gallery);
